import React from 'react';
import Create from '../../rest/Create';
import Form from '../components/Form';

const PaymentsCreate = props => (
  <Create {...props} resource="payments">
    <Form />
  </Create>
);

PaymentsCreate.propTypes = {};

export default PaymentsCreate;
